import { LOGIN, LOGIN_FAILURE, LOGIN_SUCCESS, 
        LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAILURE,
        GET_USER, GET_USER_FAILURE, GET_USER_SUCCESS,
        PATIENT_FORM_DETAILS, PATIENT_FORM_DETAILS_SUCCESS, PATIENT_FORM_DETAILS_FAILURE,
        GET_PATIENTS, GET_PATIENTS_SUCCESS, GET_PATIENTS_FAILURE,
        CHANGE_PASSWORD, CHANGE_PASSWORD_FAILURE, CHANGE_PASSWORD_SUCCESS,
        GET_PATIENT, GET_PATIENT_FAILURE, GET_PATIENT_SUCCESS,
        GET_PERFORMAONE, GET_PERFORMAONE_FAILURE, GET_PERFORMAONE_SUCCESS,
        GET_SCANS, GET_SCANS_FAILURE, GET_SCANS_SUCCESS,
        GET_XRAY, GET_XRAY_FAILURE, GET_XRAY_SUCCESS,
        GET_DISORDER_ANS_TREATMENT, GET_DISORDER_ANS_TREATMENT_FAILURE, GET_DISORDER_ANS_TREATMENT_SUCCESS,
        GET_CLINICAL_FEATURE, GET_CLINICAL_FEATURE_FAILURE, GET_CLINICAL_FEATURE_SUCCESS,
        GET_DEXA, GET_DEXA_FAILURE, GET_DEXA_SUCCESS, 
        GET_INVESTIGATION, GET_INVESTIGATION_FAILURE, GET_INVESTIGATION_SUCCESS,
        GET_DEXA1, GET_DEXA1_SUCCESS, GET_DEXA1_FAILURE,
        GET_DEXA3, GET_DEXA3_SUCCESS, GET_DEXA3_FAILURE,
        GET_HRPQCT,GET_HRPQCT_FAILURE,GET_HRPQCT_SUCCESS} from '../Utils/Constants';

const initialState = {
    loading: false,
    errors: {},
    success: {}
}

export const errorAndLoadingReducer = (state = initialState, action) => {
    if( action.type === LOGIN || action.type === LOGOUT || 
        action.type === GET_USER || action.type === PATIENT_FORM_DETAILS || 
        action.type === GET_PATIENTS || action.type === CHANGE_PASSWORD ||
        action.type === GET_PATIENT || action.type === GET_SCANS ||
        action.type === GET_PERFORMAONE || action.type === GET_XRAY ||
        action.type === GET_DISORDER_ANS_TREATMENT || action.type === GET_CLINICAL_FEATURE ||
        action.type === GET_INVESTIGATION || action.type === GET_DEXA || 
        action.type === GET_DEXA1 || action.type === GET_DEXA3||
        action.type === GET_HRPQCT) {
        return {
            ...initialState,
            loading: action.payload.loading,
            errors: {}
        }
    }
    if( action.type === LOGIN_SUCCESS || action.type === LOGOUT_SUCCESS || 
        action.type === GET_USER_SUCCESS || action.type === PATIENT_FORM_DETAILS_SUCCESS || 
        action.type === GET_PATIENTS_SUCCESS || action.type === CHANGE_PASSWORD_SUCCESS ||
        action.type === GET_PATIENT_SUCCESS || action.type === GET_SCANS_SUCCESS ||
        action.type === GET_PERFORMAONE_SUCCESS || action.type === GET_XRAY_SUCCESS ||
        action.type === GET_DISORDER_ANS_TREATMENT_SUCCESS || action.type === GET_CLINICAL_FEATURE_SUCCESS ||
        action.type === GET_DEXA_SUCCESS || action.type === GET_INVESTIGATION_SUCCESS || 
        action.type === GET_DEXA1_SUCCESS || action.type === GET_DEXA3_SUCCESS || action.type === GET_HRPQCT_SUCCESS) {
        return {
            ...initialState,
            loading: action.payload.loading,
            success: action.payload.success?action.payload.success:{},
        }
    }
    if( action.type === LOGIN_FAILURE || action.type === LOGOUT_FAILURE || 
        action.type === GET_USER_FAILURE || action.type === PATIENT_FORM_DETAILS_FAILURE || 
        action.type === GET_PATIENTS_FAILURE || action.type === CHANGE_PASSWORD_FAILURE ||
        action.type === GET_PATIENT_FAILURE || action.type === GET_SCANS_FAILURE ||
        action.type === GET_PERFORMAONE_FAILURE || action.type === GET_XRAY_FAILURE ||
        action.type === GET_DISORDER_ANS_TREATMENT_FAILURE || action.type === GET_CLINICAL_FEATURE_FAILURE ||
        action.type === GET_DEXA_FAILURE || action.type === GET_INVESTIGATION_FAILURE ||
        action.type === GET_DEXA1_FAILURE || action.type === GET_DEXA3_FAILURE || action.type === GET_HRPQCT_FAILURE
        ) {
        return {
            ...initialState,
            loading: action.payload.loading,
            errors: action.payload.errors,
        }
    }

    return state;
}
